// One email check for the whole web app (QA batch 12, 2026-10-21). The same
// rule is in the backend (`Services/ContactInputRules.cs` IsValidEmail): the
// common RFC 5322 characters are allowed before the @
// (letters, digits and ! # $ % & ' * + / = ? ^ _ ` { | } ~ . -), the domain
// needs a dot and a 2+ letter ending. Before, several boxes refused ! or #.

const EMAIL_PATTERN =
  /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;

export const INVALID_EMAIL = "Invalid email address format";

export const isValidEmail = (value?: string | null): boolean => {
  const email = (value || "").trim();
  if (!email || email.length > 254 || email.includes("..")) return false;
  if (email.startsWith(".") || email.split("@")[0]?.endsWith(".")) return false;
  if (!EMAIL_PATTERN.test(email)) return false;
  const ending = email.split("@")[1]?.split(".").pop() || "";
  return ending.length >= 2 && /^[A-Za-z]+$/.test(ending);
};

/** react-hook-form `validate` for an optional email box. */
export const validateEmail =
  (message: string = INVALID_EMAIL) =>
  (value?: string | null): true | string =>
    !(value || "").trim() || isValidEmail(value) ? true : message;
